import React from 'react';
import ScreenComponent from './ScreenComponent';
import { RecipesList } from './recipes/RecipesList';
import { RecipePreview } from "./recipes/RecipePreview";
import { RecipeEdit } from "./recipes/RecipeEdit";
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert, topbarUpdate, openLink } from "../../actions";
import { config } from "../../app/config";
import axios from "axios";
import '../../styles/elements/screen.scss';
import '../../styles/headers.scss';
import '../../styles/screens/recipes.scss';
import TranslationService from "../../app/services/TranslationService";


class RecipesScreenClass extends ScreenComponent {

    /**
     * @param props
     */
    constructor(props)
    {
        super(props);

        this.state = {
            data: [],
            subscreen: 'list',
            recipe: {name: '', public: false, ingredients: '', recipe: ''}
        };
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.view !== this.getScreenName() && this.props.view === this.getScreenName()) {
            this.loadData();
            this.props.topbarUpdate({
                action1: null,
                action2: null,
                actionBig: null
            });

            this.openElementFromLink();
        }
    };

    openElementFromLink = () => {
        if (this.props.link !== null) {
            const recipeToOpen = this.props.link;
            this.props.openLink(null);
            this.openRecipe(recipeToOpen);
        }
    }

    getScreenName() {
        return 'recipes';
    }

    loadData = () => {
        this.props.preloaderShow();
        let that = this;

        that.setState({data: []});
        axios.get(config.apiAddress + '/app/recipe/list')
            .then(function (response) {
                that.setState({data: response.data});
                that.props.preloaderHide();
            }).catch(function(error) {
            that.props.alert('Nie udało się załadować danych');
            that.props.preloaderHide();
        });
    };

    saveRecipe = (data) => {
        this.props.preloaderShow();
        let that = this;

        if (data.id !== undefined) {
            axios.put(config.apiAddress + '/app/recipe/' + data.id, data)
                .then(function (response) {
                    that.setState({subscreen: 'list', recipe: {}});
                    that.props.alert('Przepis został zapisany');
                    that.loadData();
                }).catch(function(error) {
                that.props.alert('Nie udało się zapisać przepisu');
                that.props.preloaderHide();
            });

            return;
        }

        axios.post(config.apiAddress + '/app/recipe', data)
            .then(function (response) {
                that.setState({subscreen: 'list', recipe: {}});
                that.props.alert('Przepis został zapisany');
                that.loadData();
            }).catch(function(error) {
            that.props.alert('Nie udało się zapisać przepisu');
            that.props.preloaderHide();
        });
    };

    openRecipe = (id) => {
        this.props.preloaderShow();
        let that = this;

        axios.get(config.apiAddress + '/app/recipe/' + id)
            .then(function (response) {
                that.setState({
                    subscreen: 'preview',
                    recipe: response.data
                });
                that.props.preloaderHide();
            }).catch(function(error) {
            that.props.alert('Nie udało się otworzyć przepisu');
            that.props.preloaderHide();
        });
    };

    openSubscreen = (name, clearRecipe) => {
        this.setState({subscreen: name})

        if (typeof clearRecipe !== 'undefined') {
            this.setState({recipe: {name: '', public: false, ingredients: '', recipe: ''}})
        }
    };

    render() {
        return (
            <div className={this.getClass()} id="screen-recipes" style={this.getStyle()}>
                <div className="content">
                    <RecipesList
                        subscreen={this.state.subscreen}
                        recipes={this.state.data}
                        openSubscreen={this.openSubscreen}
                        openRecipe={this.openRecipe}
                        lang={this.props.language}
                    />

                    <RecipePreview
                        subscreen={this.state.subscreen}
                        recipe={this.state.recipe}
                        openSubscreen={this.openSubscreen}
                        lang={this.props.language}
                    />

                    <RecipeEdit
                        subscreen={this.state.subscreen}
                        recipe={this.state.recipe}
                        openSubscreen={this.openSubscreen}
                        saveRecipe={this.saveRecipe}
                        reloadData={this.loadData}
                        lang={this.props.language}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        email: state.login.email,
        device: state.login.device,
        user: state.user,
        view: state.view,
        language: TranslationService.getLanguage(state.user),
        link: state.link
    }
};

export const RecipesScreen = connect(mapStateToProps, { preloaderShow, preloaderHide, alert, topbarUpdate, openLink })(RecipesScreenClass);
